import { Component, inject, computed, ChangeDetectionStrategy } from '@angular/core';

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterOutlet } from '@angular/router';
import { ThemeService } from '../../core/services/theme.service';
import { AuthService } from '../../core/services/auth.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatDividerModule,
    RouterOutlet
],
  templateUrl: './layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {
  themeService = inject(ThemeService);
  private authService = inject(AuthService);
  private router = inject(Router);

  currentYear = new Date().getFullYear();
  public readonly userProfile = this.authService.userProfile;
  username = computed(() => this.userProfile()?.username || 'Benutzer');


  logout(): void {
    this.authService.logout();
  }

  toggleTheme() {
    this.themeService.toggleTheme();
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  protected readonly sessionStorage = sessionStorage;

  getCustomerName() {
    const account: any = sessionStorage.getItem('account');
    return account ?  JSON.parse(account).name : '';
  }

  getIdf() {
    const account: any = sessionStorage.getItem('account');
    return account ?  JSON.parse(account).idf : '';
  }
}
